import React from 'react';
import { IonCol, IonGrid, IonRow, IonText } from '@ionic/react';


const Billing: React.FC = () => {
    return (
        <IonGrid>
            <IonRow className="board-title">
                <IonCol>
                    <IonText>
                        <h2>BILLING</h2>
                    </IonText>
                </IonCol>
            </IonRow>
        </IonGrid>
    )
}

export default Billing;
